export const environment = {
  production: true,
  baseUrl: 'https://app.termsheet.com',
  apiVersion: 'api/v2',
  versionCheckURL: 'https://dashboard.termsheet.com/version.json',
  cookieDomain: 'termsheet.com',
  appDomain: 'termsheet.com',
  tilesApi: {
    url: 'https://www.parceled.com',
    authToken: '50ED635ABAB395CAFA86',
  },
  google: {
    streetViewKey: 'AIzaSyDv7GjiEXfaV-oWTZBL5gJcwniQTBElk0I',
  },
  mapbox: {
    accessToken: 'pk.eyJ1Ijoicm9nZXNtaXRoIiwiYSI6ImNqdHB2OHg5azAwbzA0M3BlZ3dxanZ2NXcifQ.PBWyfzuqPZMB6EaL6mQdvQ',
  },
  env: 'productionUI',
  dataDog: {
    env: 'production',
    applicationId: '85021521-7384-462b-9cdd-488274177f7f',
    clientToken: 'pubd6650380605cdb2ee230a12936ee9069',
    site: 'datadoghq.com',
    service: 'termsheet-frontend',
    version: '2714a4c976',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
  },
  pusher: {
    instanceLocator: 'v1:us1:293dfee0-776e-4024-accd-63f80b5d820f',
    instanceId: 'a25019c4-722b-4788-8433-a50e4bce4a5d',
    channelApp: {
      key: 'fe1978251c8e679925f1',
      cluster: 'us2',
    },
  },
  rollbar: {
    codeVersion: '2714a4c976',
    accessToken: '1b1a90d4408b492f88af7ce6b2f9802a',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: 'productionUI',
      client: {
        javascript: {
          source_map_enabled: true,
          guess_uncaught_frames: true,
          code_version: '2714a4c976',
        },
      },
    },
    transform: function (payload) {
      let trace = payload.body.trace;
      // Change 'yourdomainhere' to your domain.
      let locRegex = /^(https?):\/\/[a-zA-Z0-9._-]+\.termsheet\.com(.*)/;
      if (trace && trace.frames) {
        for (let i = 0; i < trace.frames.length; i++) {
          let filename = trace.frames[i].filename;
          if (filename) {
            let m = filename.match(locRegex);
            // Be sure that the minified_url when uploading includes 'dynamichost'
            trace.frames[i].filename = m[1] + '://dynamichost' + m[2];
          }
        }
      }
    },
  },
  analytics: {
    segmentWriteKey: 'lBxS2VT8cuCT4qeWEE7jGhQYoyFYIi4m',
  },
  syncfusion: {
    licenseKey: 'Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXxfd3VWRmBYWU1+XkA=',
  },
  hubspot: {
    chatbotScriptId: '6152449',
  },
  ethanAbilities: {
    apiKey: 'ea-aOzGvwRxpv6KI0G3zgK088i6vw8qWUxNj-aLEheA5Ic',
  },
  celeste: {
    domain: 'my.intapp.com',
    platform: 'termsheet',
  },
  pendo: {
    apiKey: '8f2f3bdd-51c6-480c-8450-cc0478ab2353',
    envSuffix: '',
  },
  enableReduxDevtools: false,
  frontEndCodeVersion: '2714a4c976',
  agGridLicenseKey:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-064514}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{TermSheet}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{TermSheet}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{TermSheet}_need_to_be_licensed___{TermSheet}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{2_August_2025}____[v3]_[01]_MTc1NDA4OTIwMDAwMA==a6ae0c4c52035689fb1c57902d2bf306',
};
